export default __webpack_public_path__ + "static/media/undraw_schedule_re_2vro.bb92fbfc.svg";